import React, { useState, useEffect, useRef } from "react";
import homeImage from "../assets/image/main_image.png";
import "bootstrap/dist/css/bootstrap.min.css";
import "../assets/css/Homepage.css";
import { useNavigate } from "react-router-dom";
import { getAllClass } from "../services/userServices";
import Calendar from "../components/Calender";

const Homepage = () => {
  const [showHide, setShowHide] = useState(false);
  const [timeFilter, setTimeFilter] = useState("all");
  const [itemsPerPage, setItemsPerPage] = useState(999999);
  const [items, setItems] = useState([]);
  const resultPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedDate, setSelectedDate] = useState(null);
  const tabbarRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (tabbarRef.current && !tabbarRef.current.contains(event.target)) {
        setShowHide(false);
      }
    }

    if (showHide) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showHide]);
  const handleDateSelect = (date) => {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    const formattedDate = `${day}/${month}/${year}`;
    setTimeFilter("byDate");
    setSelectedDate(formattedDate);
  };

  const navigate = useNavigate();
  const logout = () => {
    localStorage.removeItem("token");
    navigate("/");
  };

  const openTabbar = () => {
    setShowHide(!showHide);
  };

  const handleNavigation = (path) => {
    navigate(path);
  };
  useEffect(() => {
    fetchClass();
  }, []);

  const fetchClass = async () => {
    const response = await getAllClass(itemsPerPage, currentPage);

    if (response && response.respObj) {
      setItems(response.respObj);
    } else {
      console.error("Invalid data: ", response);
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const formatDate = (date) => {
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const formatToISO = (dateString) => {
    const [day, month, year] = dateString.split("/");
    const date = new Date(`${year}-${month}-${day}T00:00:00.000Z`);
    return date.toISOString();
  };

  const filterClasses = (classes, filter) => {
    const now = new Date();
    switch (filter) {
      case "today":
        return classes.filter((item) => {
          const classDate = new Date(formatToISO(item.time));
          return (
            classDate.getDate() === now.getDate() &&
            classDate.getMonth() === now.getMonth() &&
            classDate.getFullYear() === now.getFullYear()
          );
        });
      case "thisWeek":
        const startOfWeek = new Date(now.setDate(now.getDate() - now.getDay()));
        const endOfWeek = new Date(
          now.setDate(now.getDate() - now.getDay() + 6)
        );
        return classes.filter((item) => {
          const classDate = new Date(formatToISO(item.time));
          return classDate >= startOfWeek && classDate <= endOfWeek;
        });
      case "thisMonth":
        return classes.filter((item) => {
          const classDate = new Date(formatToISO(item.time));
          return (
            classDate.getMonth() === now.getMonth() &&
            classDate.getFullYear() === now.getFullYear()
          );
        });
      case "thisYear":
        return classes.filter((item) => {
          const classDate = new Date(formatToISO(item.time));
          return classDate.getFullYear() === now.getFullYear();
        });
      case "byDate":
        const selectedDateObj = new Date(formatToISO(selectedDate));
        return classes.filter((item) => {
          const classDate = new Date(formatToISO(item.time));
          return (
            classDate.getDate() === selectedDateObj.getDate() &&
            classDate.getMonth() === selectedDateObj.getMonth() &&
            classDate.getFullYear() === selectedDateObj.getFullYear()
          );
        });
      case "all":
      default:
        return classes;
    }
  };

  const groupedClasses = items.reduce((acc, current) => {
    const date = formatDate(current.createdAt);
    if (!acc[date]) {
      acc[date] = [];
    }
    acc[date].push(current);
    return acc;
  }, {});

  const result = Object.keys(groupedClasses).map((date) => ({
    time: date,
    totalOfClasses: groupedClasses[date].length,
  }));
  const filteredResult = filterClasses(result, timeFilter);

  const totalPages = Math.ceil(filteredResult.length / resultPerPage);
  const paginatedResult = filteredResult.slice(
    (currentPage - 1) * resultPerPage,
    currentPage * resultPerPage
  );
  return (
    <>
      <div ref={tabbarRef} className={`tabbar ${showHide ? "open" : ""}`}>
        <ul>
          <li>
            <svg
              style={{ cursor: "pointer" }}
              onClick={openTabbar}
              fill="#000000"
              width="24px"
              height="24px"
              viewBox="0 -2 28 28"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
              <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></g>
              <g id="SVGRepo_iconCarrier">
                <path d="m5.216 11.998c0 1.44-1.168 2.608-2.608 2.608s-2.608-1.168-2.608-2.608 1.168-2.608 2.608-2.608 2.608 1.168 2.608 2.608z"></path>
                <path d="m5.216 2.608c0 1.44-1.168 2.608-2.608 2.608s-2.608-1.168-2.608-2.608 1.168-2.608 2.608-2.608 2.608 1.168 2.608 2.608z"></path>
                <path d="m5.216 21.389c0 1.44-1.168 2.608-2.608 2.608s-2.608-1.168-2.608-2.608 1.168-2.608 2.608-2.608 2.608 1.168 2.608 2.608z"></path>
                <path d="m9.794 0h15.247c1.441 0 2.61 1.168 2.61 2.61s-1.168 2.61-2.61 2.61h-15.247c-1.441 0-2.61-1.168-2.61-2.61s1.168-2.61 2.61-2.61z"></path>
                <path d="m9.794 9.39h15.247c1.441 0 2.61 1.168 2.61 2.61s-1.168 2.61-2.61 2.61h-15.247c-1.441 0-2.61-1.168-2.61-2.61s1.168-2.61 2.61-2.61z"></path>
                <path d="m9.794 18.781h15.247c1.441 0 2.61 1.168 2.61 2.61s-1.168 2.61-2.61 2.61h-15.247c-1.441 0-2.61-1.168-2.61-2.61s1.168-2.61 2.61-2.61z"></path>
              </g>
            </svg>
          </li>
          <li>
            <div
              className="option-tab"
              onClick={() => handleNavigation("/home")}
            >
              Home
            </div>
          </li>
          <li>
            <div
              className="option-tab"
              onClick={() => handleNavigation("/manage-license")}
            >
              License
            </div>
          </li>
          <li>
            <div
              className="option-tab"
              onClick={() => handleNavigation("/manage-logo")}
            >
              Manage logo
            </div>
          </li>
          <li>
            <div
              className="option-tab"
              onClick={() => handleNavigation("/change-password")}
            >
              Change password
            </div>
          </li>
        </ul>
      </div>
      <div
        style={{
          backgroundImage: `url(${homeImage})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          minHeight: "300px",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          //   alignItems: "center",
          //   justifyContent: "center",
          textAlign: "center",
          color: "black",
          fontSize: "2rem",
          fontWeight: "bold",
          textShadow: "2px 2px 4px rgba(0,0,0,0.5)",
          position: "relative",
        }}
      >
        <div className="top-action">
          <svg
            style={{ cursor: "pointer" }}
            onClick={openTabbar}
            fill="#000000"
            width="24px"
            height="24px"
            viewBox="0 -2 28 28"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
              id="SVGRepo_tracerCarrier"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
              <path d="m2.61 0h22.431c1.441 0 2.61 1.168 2.61 2.61s-1.168 2.61-2.61 2.61h-22.431c-1.441 0-2.61-1.168-2.61-2.61s1.168-2.61 2.61-2.61z"></path>
              <path d="m2.61 9.39h22.431c1.441 0 2.61 1.168 2.61 2.61s-1.168 2.61-2.61 2.61h-22.431c-1.441 0-2.61-1.168-2.61-2.61s1.168-2.61 2.61-2.61z"></path>
              <path d="m2.61 18.781h22.431c1.441 0 2.61 1.168 2.61 2.61s-1.168 2.61-2.61 2.61h-22.431c-1.441 0-2.61-1.168-2.61-2.61s1.168-2.61 2.61-2.61z"></path>
            </g>
          </svg>
          <div
            style={{
              // position: "absolute",
              right: "10px",
              top: "20px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "14px",
              cursor: "pointer",
            }}
            onClick={logout}
          >
            <svg
              width="24px"
              height="24px"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
              <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></g>
              <g id="SVGRepo_iconCarrier">
                {" "}
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M9 0L3 2V14H1V16H15V14H13V2H11V14H9V0ZM6.75 9C7.16421 9 7.5 8.55229 7.5 8C7.5 7.44772 7.16421 7 6.75 7C6.33579 7 6 7.44772 6 8C6 8.55229 6.33579 9 6.75 9Z"
                  fill="#000000"
                ></path>{" "}
              </g>
            </svg>
            Logout
          </div>
        </div>
        Cloud AI lecture system
      </div>
      <div className="dashboard">
        <h2 className="dashboard-title">Dashboard</h2>
        <div style={{ fontSize: "14px", marginBottom: "20px" }}>
          Statistic class by time
        </div>
        <div className="filter-container">
          <div className="filter-buttons">
            {["all", "today", "thisWeek", "thisMonth", "thisYear"].map(
              (filter) => (
                <button
                  key={filter}
                  className={`filter-button ${timeFilter === filter ? "active" : ""}`}
                  onClick={() => {
                    setTimeFilter(filter);
                  }}
                >
                  {filter === "all"
                    ? "All"
                    : filter === "today"
                      ? "Today"
                      : filter === "thisWeek"
                        ? "This Week"
                        : filter === "thisMonth"
                          ? "This Month"
                          : "This Year"}
                </button>
              )
            )}
          </div>
        </div>
        <div className="d-flex justify-content-between">
          <div className="calendar-container">
            <Calendar onDateSelect={handleDateSelect} />
          </div>

          {paginatedResult.length === 0 ? (
            <div className="table-container">
              <div className="table-responsive">
                <div className="no-data">No data available</div>
              </div>
            </div>
          ) : (
            <div className="table-container">
              <div className="table-responsive">
                <table className="table table-bordered table-hover">
                  <thead className="table-light">
                    <tr>
                      <th>#</th>
                      <th>Time</th>
                      <th>Total of classes</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paginatedResult.map((item, index) => {
                      return (
                        <>
                          <tr key={`${item.time}-${index}`}>
                            <td>
                              {(currentPage - 1) * resultPerPage + index + 1}
                            </td>
                            <td>{item.time}</td>
                            <td>{item.totalOfClasses}</td>
                          </tr>
                        </>
                      );
                    })}
                  </tbody>
                </table>
              </div>
              <nav className="mt-3">
                <ul className="pagination justify-content-center">
                  <li
                    className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                  >
                    <button
                      className="page-link"
                      onClick={() => handlePageChange(currentPage - 1)}
                    >
                      Prev
                    </button>
                  </li>

                  {Array.from({ length: totalPages }, (_, i) => (
                    <li
                      key={i}
                      className={`page-item ${currentPage === i + 1 ? "active" : ""}`}
                    >
                      <button
                        className="page-link"
                        onClick={() => handlePageChange(i + 1)}
                      >
                        {i + 1}
                      </button>
                    </li>
                  ))}

                  <li
                    className={`page-item ${
                      currentPage === totalPages ? "disabled" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() => handlePageChange(currentPage + 1)}
                    >
                      Next
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Homepage;
